import * as React from 'react';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { ConnectedAllCollectionsSpace } from './ConnectedAllCollectionsSpace';

export interface AllCollectionsSpaceProviderProps extends ReactDirectiveProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
}

const AllCollectionsSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'collections',
  subspaceName: undefined
};

export const AllCollectionsSpaceProvider: React.FunctionComponent<AllCollectionsSpaceProviderProps> = (props) => {

  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllCollectionsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllCollectionsSpace angularContext={props.angularContext} />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
